import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'saniteizeImage' })
export class SaniteizeImagePipe implements PipeTransform {

  constructor(public _sanitizer?: DomSanitizer) {}

  transform(value: any, args?: any): any {
    return this._sanitizer.bypassSecurityTrustStyle(`url('${value}')`);
  }

}
